/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';
angular.module('prism-ui.content').controller('AddContentCategoriesModalController',
    function ($uibModalInstance, ContentEditService, availableCategories, existingContentCategories) {
        var self = this;

        self.filteredLongFormCategories = [];
        self.filteredShortFormCategories = [];
        self.categoryTypes = [];
        self.catTypeMap = {
            'Long Form': [],
            'Short Form': []
        };

        self.selectedCategoryType = '';
        self.selectedCategory = '';

        self.setContentCategoryCollections = function () {
            angular.forEach(availableCategories, function (categoryType) {
                self.categoryTypes.push(categoryType.name);
            });

            var existingCategories = existingContentCategories.map(function (contentCat) {
                return contentCat.category.id;
            });

            self.filteredLongFormCategories = availableCategories[0].categories.filter(function (cat) {
                return existingCategories.indexOf(cat.id) === -1;
            });

            self.filteredShortFormCategories = availableCategories[1].categories.filter(function (cat) {
                return existingCategories.indexOf(cat.id) === -1;
            });

            self.catTypeMap = {'Long Form': self.filteredLongFormCategories, 'Short Form': self.filteredShortFormCategories};
        };

        self.onOk = function () {
            $uibModalInstance.close({category: self.selectedCategory, id: -1});
        };

        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.disableOKButton = function () {
            return self.selectedCategory === '' || self.modalForm.$pristine;
        };

        self.setContentCategoryCollections();

    });
